<template>
  <m-list separator>
    <q-item
      v-for="(thread, index) in threadsFiltered"
      :key="index"
      v-ripple
      clickable
      :active="thread.id === threadSelectedId"
      @click="$emit('thread-selected-id', thread.id)"
    >
      <m-item-section>
        <m-item-label>{{ fetchLabel(thread) }}</m-item-label>
        <m-item-label caption>{{ fetchCaption(thread) }}</m-item-label>
      </m-item-section>
    </q-item>
  </m-list>
</template>

<script>
import MList from "../../MList";
import MItemLabel from "../../MItemLabel";
import MItemSection from "../../MItemSection";
import { QItem } from "quasar";

export default {
  components: {
    QItem,
    MList,
    MItemSection,
    MItemLabel,
  },
  props: {
    threadsFiltered: {
      type: Array,
      default: null,
    },
    threadSelectedId: {
      type: String,
      default: null,
    },
  },

  methods: {
    fetchLabel(thread) {
      let threadItem = thread.threadItems[thread.threadItems.length - 1];

      return this.fetchLabelByType(threadItem, threadItem.type);
    },
    fetchLabelByType(threadItem, type) {
      switch (type) {
        case "inbound-letter":
          return threadItem.inboundLetter.sender;
        case "outbound-sms":
          return "SMS to: " + threadItem.outboundSms.patient.label;
        case "inbound-sms":
          return "SMS from: " + threadItem.inboundSms.patient.label;
        default:
          return "Unsupported type: " + type;
      }
    },
    fetchCaption(thread) {
      let threadItem = thread.threadItems[thread.threadItems.length - 1];

      return this.fetchCaptionByType(threadItem, threadItem.type);
    },
    fetchCaptionByType(threadItem, type) {
      switch (type) {
        case "inbound-letter":
          return threadItem.inboundLetter.summary;
        case "outbound-sms":
          return threadItem.outboundSms.status;
        case "inbound-sms":
          return threadItem.inboundSms.status;
        default:
          return "Unsupported type: " + type;
      }
    },
  },
};
</script>
